import { useState } from 'react';
import { useNavigate } from 'react-router';
import { paths } from '../../common/constants/pathVariables';
import { deprecateVirtualCatalog } from '../../common/fetch';
import { confirmMsg, t } from '../../common/i18n';
import { addNotification } from '../../public/site/notificationStore.js';
import { ConfirmationDialog } from '../ConfirmationDialog';

interface DeleteDeviceListDialogProps {
  accountMasterId?: string;
  catalogName: string;
  virtualCatalogCode: string;
}

export const DeleteCatalogDialog = ({
  accountMasterId,
  catalogName,
  virtualCatalogCode,
}: DeleteDeviceListDialogProps) => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onDeleteCatalog = async () => {
    try {
      setIsSubmitting(true);
      await deprecateVirtualCatalog(virtualCatalogCode, accountMasterId);
      navigate(paths.COMPANY_INFO_CATALOGS, { replace: true });
    } catch {
      addNotification(t.L0X1('Failed to delete the catalogue'), 'error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <ConfirmationDialog
      body={<div>{catalogName}</div>}
      confirmButtonText={t.QVYK(confirmMsg)}
      header={t.WGM5('Confirm deletion of device list')}
      hideClosingCross={false}
      isLoading={isSubmitting}
      onCloseDialog={() => navigate(location.search)}
      onConfirm={onDeleteCatalog}
    />
  );
};
